import React, { cloneElement, useEffect, useState } from 'react';
import { default as __ } from '../utils';

import './radio.css';

const { count, map } = React.Children;

function RadioGroup({ children, initial, name, onUpdate }) {
  const [ioValue, setIOValue] = useState(initial);
  const [ioValueKey, setIOkey] = useState(name); // eslint-disable-line

  const onChange = e => {
    setIOValue(e.target.value);
  };

  useEffect(() => {
    onUpdate(ioValueKey, ioValue);
  }, [ioValue]);

  useEffect(() => {
    setIOValue(initial);
  }, [initial]);

  return (
    <div io-radio="container">
      {map(children, c => {
        const { name } = c.props;
        return cloneElement(c, {
          ...c.props,
          name,
          checked: ioValue === name ? true : false,
          onChange,
          flexBase: __.roundTo(100 / count(children), 0),
        });
      })}
    </div>
  );
}

RadioGroup.displayName = 'IORadioGroup';
export default RadioGroup;

function Radio({ checked, disabled = false, flexBase, label, name, onChange }) {
  let inputLabel =
    typeof label === 'string' ? (
      <label
        htmlFor={name}
        io-radio="label"
        style={{
          fontWeight: checked ? '600' : '400',
        }}
      >
        {label}
      </label>
    ) : (
      label({
        checked,
        label,
        htmlFor: name,
      })
    );

  return (
    <div
      io-radio="field"
      style={{
        position: 'relative',
        flex: `1 0 ${flexBase}%`,
      }}
    >
      <div io-radio-pinned="">{inputLabel}</div>
      <input
        io-radio="input"
        disabled={disabled}
        name={name}
        value={name}
        checked={checked}
        type="radio"
        onChange={onChange}
      />
    </div>
  );
}

export { Radio };
